import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <MDBFooter  className='text-center text-lg-start text-muted '>
      

      <section className='text-dark'>
        <div className='container-full-width text-md-start py-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="6" lg="6" xl="6" className='mx-auto mb-4'>
              <h6 className='text-uppercase  mb-4'>
                <MDBIcon icon="gem" className="me-3" />
                TOP TECH GIANTS
              </h6>
              <p>
              Top Tech Giants is the team of most skilled coders. We create incredible digital experiences.
              </p>
            </MDBCol>

            

            <MDBCol md="6" lg="6" xl="6" className='mx-auto mb-md-0 mb-4'>
              
              <div className='contact-emails-wrapper'>
                <h6 className='text-uppercase  mb-4'>CONTAC EMAILS.</h6>
                
                <p>
                  <a className='text-dark text-decoration-none' href='mailto:info@toptechgiants.com'>
                  <MDBIcon icon="envelope" className="me-3" />
                  info@toptechgiants.com
                  </a>
                </p>
                <p>
                  <a className='text-dark text-decoration-none' href='mailto:sudarshanhang@gmail.com'>
                    <MDBIcon icon="envelope" className="me-3" />
                    sudarshanhang@gmail.com
                    </a>
                </p>
              </div>
             {/* <p>
              <a target='_blank' className='text-dark text-decoration-none' href='https://www.linkedin.com/in/toptechgiants/' >
                <MDBIcon fab icon="linkedin" className='me-3' />
                linkedin.com/in/toptechgiants
              </a>
             </p> */}
             {/* <p>
              <a className='text-dark text-decoration-none' href='https://github.com/sudarshangiri' >
                <MDBIcon fab icon="linkedin" className='me-3' />
               github.com/sudarshangiri
              </a>
             </p> */}
              {/* <p className='text-dark text-decoration-none'>
                <MDBIcon icon="home" className="me-3" />
                Lalitpur, Nepal
              </p> */}
            
             
            </MDBCol>
          </MDBRow>
        </div>
      </section>

      <div className='p-4 border-top text-dark border-bottom' >
        © {currentYear} Copyright:
          toptechgiants.com
        
      </div>
    </MDBFooter>
  );
}
